import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-catalog-product-category-panel',
  templateUrl: './catalog-product-category-panel.component.html',
  styleUrls: ['./catalog-product-category-panel.component.scss'],
  imports: [TranslateModule, MatExpansionModule, MatIconModule, NgClass],
  standalone: true,
})
export class CatalogProductCategoryPanelComponent {
    @Input() dosage!: { code: string; dosage: string | null; description: string };
    @Input() index!: number;
    @Input() background: string = '';
    expandedPanelId: number | null = null;
    get rowClass(): string {
        return this.index % 2 === 0 ? 'surface-page' : 'surface-brand-light';
    }
    
    onPanelOpened(): void {
        this.expandedPanelId = this.index;
    }
      
    onPanelClosed(): void {
      if (this.expandedPanelId === this.index) {
         this.expandedPanelId = null;
        }
    }
}